var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-navigation-drawer', {
    staticClass: "secondary",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": "",
      "right": ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "to": "/calls/list",
      "ripple": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("build")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.calls')))])], 1)], 1), _c('v-list-tile', {
    attrs: {
      "to": "/help",
      "ripple": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("help")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.help')))])], 1)], 1), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function click($event) {
        return _vm.reloadApp();
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("refresh")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.refresh')))])], 1)], 1), _c('v-list-tile', {
    attrs: {
      "to": "/offline-requests",
      "ripple": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("wifi_off")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Offline Requests")])], 1)], 1), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    },
    on: {
      "click": _vm.logoutClicked
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("lock")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.logout')))])], 1)], 1)], 1), _c('v-divider'), _vm.user ? _c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Logged in as: " + _vm._s(_vm.user.full_name))])], 1)], 1), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Version: " + _vm._s(_vm.version))])], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }